import React from 'react';
import ReactDOM from 'react-dom';
import charChoose from '../shared/CharChoose';

class LcChoose extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charChoose(LcChoose, 'lc');


// WEBPACK FOOTER //
// ./src/components/sections/lc/LcChoose.js